{
  "CSServiceForms": {
    "wizard": {
      "steps": {
        "optionalFeedback": {
          "additionalCommentsRequired": {
            "description": "Write your comments here",
            "label": "Additional comments",
            "maxLength": "Maximum length is 3,000 characters.",
            "maxlength": "Maximum length is 3,000 characters."
          }
        }
      }
    }
  }
}
